import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import amplitude from 'amplitude-js'

import materials from '../../constants/galleriumMaterials'
import routes from '../../routes'
import { COLORS } from '../../styles/theme'

const MobileGalleriumInfographicsItem = ({ currentUser }) => {
  const [zoomIndex, setZoomIndex] = useState(-1)

  useEffect(() => {
    amplitude.getInstance().logEvent(`Visit Gallery`)
  }, [currentUser.id])

  return (
    <div>
      <Page>
        <div className="outer-wrapper">
          <div className="container">
            <div className="title-container">
              <p className="title">Gallery</p>
              <Link className="back-button" to={routes.lobby}>
                Back
              </Link>
            </div>

            <div className="video-container">
              <h1>COMING SOON</h1>
            </div>
          </div>
        </div>
      </Page>
    </div>
  )
}

const Page = styled.div`
  background: white;
  height: calc(100% - 60px);
  width: 100vw;
  overflow-y: scroll;
  border-radius: 0px 0px 25px 25px;
  position: absolute;

  .outer-wrapper {
    width: 100%;
  }
  .video-container {
    text-align: center;
    color: ${COLORS.primary};
    font-weight: 600;
  }
  .container {
    width: 90%;
    margin: auto;
  }

  .title-container {
    margin: 30px 0px 10px 0px;
    height: 100px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .title {
    width: 80%;
    font-size: 22px;
    font-weight: bold;
    font-style: italic;
    color: black;
    margin: 0;
  }

  .back-button {
    font-size: 12px;
    color: #312384;
    font-weight: bold;
    margin-top: 10px;
  }

  .list-container {
    width: 100%;
    column-count: 2;
  }

  .list-item {
    width: 100%;
  }

  .list-image {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
  }

  .image-zoom {
    width: 100%;
  }

  @media screen and (min-width: 540px) {
    .outer-wrapper {
      width: 540px;
      margin: auto;
    }
  }
`

export default MobileGalleriumInfographicsItem
